import * as React from "react"

import { cn } from "@/lib/utils"

interface InputProps extends React.ComponentProps<"input"> {
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  divClass?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, leftIcon, rightIcon, divClass, ...props }, ref) => {
    return (
      <div className={cn("relative flex h-fit items-center", divClass)}>
        <div className="text-gray-400 absolute left-[15px] top-1/2   h-5 w-5 -translate-y-1/2">
          {leftIcon}
        </div>
        <input
          type={type}
          className={cn(
            "flex h-[50px] w-full border border-[#c5c5c5] bg-transparent px-3 py-1 text-sm outline-none transition-colors focus_border-[#555] disabled_cursor-not-allowed disabled_opacity-50",
            leftIcon ? "pl-[44px]" : "",
            className
          )}
          ref={ref}
          {...props}
        />
        <div className="text-gray-400 absolute right-[15px] top-1/2   h-5 w-5 -translate-y-1/2">
          {rightIcon}
        </div>
      </div>
    )
  }
)

Input.displayName = "Input"

export { Input }
